import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f8252ab2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f8252ab2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8252ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8252ab2')) {
      api.createRecord('f8252ab2', component.options)
    } else {
      api.reload('f8252ab2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f8252ab2&scoped=true", function () {
      api.rerender('f8252ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/home/index.vue"
export default component.exports